import { TourService } from 'ngx-tour-ngx-bootstrap';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { INgxbStepOption } from 'ngx-tour-ngx-bootstrap/lib/step-option.interface';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
@Component({
  selector: 'ngx-app',
  template: `
  <router-outlet></router-outlet>
  
  `
})
export class AppComponent implements OnInit, OnDestroy {

  constructor(private analytics: AnalyticsService, private translate: TranslateService,) {}


  ngOnInit() {
    this.analytics.trackPageViews();
  }

  ngOnDestroy(): void {
    this.analytics.stopTrackingPageView();
  }

}
